import { render, staticRenderFns } from "./PendingBillRequestIdleAlert.vue?vue&type=template&id=48e1c516&"
import script from "./PendingBillRequestIdleAlert.vue?vue&type=script&lang=js&"
export * from "./PendingBillRequestIdleAlert.vue?vue&type=script&lang=js&"
import style0 from "./PendingBillRequestIdleAlert.vue?vue&type=style&index=0&id=48e1c516&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports